import React, { useState } from 'react';
import AppointmentTypeCard from "./appointment_type/AppointmentTypeCard";
import DoctorsList from "./doctor_booking/DoctorsList";
import DoctorsCard from "./doctor_booking/DoctorsCard";
import ManageAppointmentType from "./appointment_type/ManageAppointmentType";
import ManageDoctor from "./doctor_booking/ManageDoctor";

const WebBooking = () => {
    const [selectedDoctor, setSelectedDoctor] = useState(null);
    const [currentView, setCurrentView] = useState('booking'); // 'doctorsList','doctorCard'

    const handleDoctorSelect = (doctor) => {
        setSelectedDoctor(doctor);
        setCurrentView('doctorCard');
    };

    const handleBackToList = () => {
        setSelectedDoctor(null);
        setCurrentView('booking');
    };
   const handleAppointmentTypeSelect = ()=>{
       setCurrentView('appointmentCard');

   }
    return (
        <>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="mb-0">
                    <i className="bi bi-globe me-2 text-primary"></i>
                    Web Booking
                </h4>
            </div>
            <div className="row">
                {currentView === 'booking' && (
                    <>
                         <div className="col-md-7">
                             <DoctorsList onDoctorSelect={handleDoctorSelect} />
                         </div>
                        <div className="col-md-5">
                            <AppointmentTypeCard onManage = {handleAppointmentTypeSelect}/>
                        </div>
                    </>
                )}
                {currentView === 'doctorCard' && (
                    <>
                        <div className="col-12">
                            <ManageDoctor
                                doctor={selectedDoctor}
                                onBack={handleBackToList}
                            />
                        </div>

                    </>
                )}
                {currentView === 'appointmentCard' && (
                    <>
                        <div className="col-12">
                            <ManageAppointmentType onBack={handleBackToList} />
                        </div>
                    </>
                )}

            </div>
        </>
    );
};

export default WebBooking;